module.exports = __webpack_public_path__ + "images/company/rank_medal/average_seconds_to_initial_reply_rank/3_203e489571a41d8650e16be3afdbddcd.png";